import { Form } from "reactstrap";
import CommonFileUpload from "../../../../CommonElements/CommonFileUpload";

const DropzoneFile = () => {
  return (
    <Form>
      <CommonFileUpload />
    </Form>
  );
};

export default DropzoneFile;
